module.exports = __webpack_public_path__ + "img/home_hero_phone.97ef5dbe.jpg";